module.exports = __webpack_public_path__ + "img/phone.4ed2df64.png";